// Don't change class names as CSS styles are associated with it

const speakers = {
  DineshPunni: {
    name: 'Dinesh Punni',
    date: '12th Nov',
    content: 'Founder, Immersive insiders',
    route: 'https://www.linkedin.com/in/dineshpunni/'
  },
  NeerajSingh: {
    name: 'Neeraj Singh',
    date: '12th Nov',
    content: 'Co-founder and CTO, Groww',
    route: 'https://www.linkedin.com/in/neeraj-singh-groww/'
  },
  AllanCampopiano: {
    name: 'Allan Campopiano',
    date: '12th Nov',
    content: 'Data Scientist, Deepnote',
    route: 'https://www.linkedin.com/in/allan-campopiano-703394120/'
  },
  JasonShah: {
    name: 'Jason Shah',
    date: '12th Nov',
    content: 'Product Management, Alchemy',
    route: 'https://www.linkedin.com/in/jasonyogeshshah'
  },
  Saket: {
    name: 'Saket',
    date: '12th Nov',
    content: 'Software Engineer, Groww',
    route: 'https://www.linkedin.com/in/saket-65261b8a/'
  },
  JohnFrancis: {
    name: 'John Francis',
    date: '12th Nov',
    content: 'Software Engineer, Groww',
    route: 'https://www.linkedin.com/in/john1jan/'
  },
  AanshulSadaria: {
    name: 'Aanshul Sadaria',
    date: '13th Nov',
    content: 'Software Engineer, Google',
    route: ' https://www.linkedin.com/in/aanshul-sadaria-31069494'
  },
  PrateekNarang: {
    name: 'Prateek Narang',
    date: '13th Nov',
    content: 'Founder, Coding Minutes',
    route: 'https://www.linkedin.com/in/prateeknarang27/'
  },
  RiddhiDutta: {
    name: 'Riddhi Dutta',
    date: '13th Nov',
    content: 'Software Engineer, Amazon',
    route: 'https://www.linkedin.com/in/riddhi-dutta/'
  },
  Sudhakar: {
    name: 'Sudhakar',
    date: '13th Nov',
    content: 'Software Engineer, Crowdstrike',
    route: 'https://sudhackar.github.io/'
  }
}

export default speakers
